// docs/141: the black between screens (`core/stores/screenCurtain`): it fades down over the screen being
// left, holds while the next one draws, and lifts. The quest path's walk into a stop has its own
// (`PathCurtain`, docs/113 QP7) in the same look.
import type { CSSProperties } from 'react';
import { closeMs, FADE_OPEN_MS, useScreenCurtain } from '../core/stores/screenCurtain';
import './screenCurtain.css';

export function ScreenCurtain() {
  const phase = useScreenCurtain((s) => s.phase);
  const kind = useScreenCurtain((s) => s.kind);
  if (phase === 'idle') return null;
  return <div className={`fk-screen-curtain fk-screen-curtain--${phase}`} style={{ ['--close-ms' as string]: `${closeMs(kind)}ms`, ['--open-ms' as string]: `${FADE_OPEN_MS}ms` } as CSSProperties}
    data-testid="screen-curtain" data-phase={phase} data-kind={kind} aria-hidden="true" />;
}
